import React from 'react';
import classNames from 'classnames';

import Loader from '../../common/Loader';
import Locale from '../../Translate/Locale';
import { generateNameFromText } from '../../../slug';

import styles from './Button.scss';

type ButtonProps = {
  onClick?: () => void;
  children: string;
  size?: ButtonSize;
  intent?: ButtonIntent;
  icon?: React.ElementType;
  isLoading?: boolean;
  disabled?: boolean;
  name?: string;
};

type ButtonSize = 'medium' | 'large';
type ButtonIntent = 'primary' | 'base' | 'danger' | 'midnight' | 'success' | 'outline' | 'warning';

function Button(props: ButtonProps) {
  const {
    children,
    size = 'medium',
    intent = 'primary',
    icon: Icon,
    isLoading,
    disabled,
    name,
    ...buttonProps
  } = props;

  const buttonName = name || generateNameFromText(children);

  const className = classNames(styles.button, styles[size], styles[intent], { [styles.loading]: isLoading });

  return (
    <button className={className} disabled={disabled || isLoading} name={buttonName} {...buttonProps}>
      {isLoading && (
        <span className={styles.loader}>
          <Loader color="#ffffff" />
        </span>
      )}
      {Icon && <Icon className={styles.icon} />}
      <span className={styles.text}>
        <Locale>{children}</Locale>
      </span>
    </button>
  );
}

export default React.memo(Button);
